module.exports = {
  cobrowse: 'cobrowse',
  title: 'CoBrowse',
  accountTypeCommercial: 'COMMERCIAL',
  buttonText: {
    accountHistoryButton: 'Account History',
    accountSearchButton: 'Manual Account Search',
    csrButton: 'CSR Report',
    stayOnCurrentPortal: 'Stay On Current Portal',
    redirectToBusiness: 'Redirect to CoBrowse Business',
    redirectToResidential: 'Redirect to CoBrowse Residential',
  },
  cobrowseDomain: {
    accountIdParam: 'accountId',
    accountNumberParam: 'ACCTNUM',
    authCodeParam: 'code',
    authorizationCode: 'authorization_code',
    divisionIdParam: 'divisionBillingId',
    cobrowseService: 'cobrowse_portal',
    cobrowseServiceAPI: 'selfservice/cobrowsedomainservice/cobrowse',
    systemErrorParam: 'error',
  },
  cobrowseURL: {
    local: {
      host: 'http://localhost:4200', // based on mock server
      commercialHost: 'http://localhost:4200', // based on mock server
      loginUrl: 'http://localhost:3000/?code=83176ee4-8e75-4fbc-a3a3-bca0e65c9c8c',
      smbLoginUrl: 'http://localhost:3000/?code=83176ee4-8e75-4fbc-a3a3-bca0e65c9c8c',
      ui: 'http://localhost:3000',
      smbUi: 'http://localhost:3000',
      specPortals: 'https://local.portals.dev-spectrum.net:1234',
      smbPortals: 'https://local.portals.dev-spectrumbusiness.net',
    },
    dev: {
      host: 'https://apis-internal-corp.shared.dev-spectrum.net',
      commercialHost: 'https://apis-internal-corp.shared.dev-spectrumbusiness.net',
      loginUrl:
        'https://apis-internal-corp.shared.dev-spectrum.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.portals.dev-spectrum.net',
      smbLoginUrl:
        'https://apis-internal-corp.shared.dev-spectrumbusiness.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.portals.dev-spectrumbusiness.net',
      ui: 'https://cobrowse.portals.dev-spectrum.net',
      smbUi: 'https://cobrowse.portals.dev-spectrumbusiness.net',
      specPortals: 'https://www.portals.dev-spectrum.net',
      smbPortals: 'https://www.portals.dev-spectrumbusiness.net',
    },
    uat: {
      host: 'https://apis-internal.portals.uat-spectrum.net',
      commercialHost: 'https://apis-internal.portals.uat-spectrumbusiness.net',
      loginUrl:
        'https://apis-internal-corp.shared.uat-spectrum.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.portals.uat-spectrum.net',
      smbLoginUrl:
        'https://apis-internal-corp.shared.uat-spectrumbusiness.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.portals.uat-spectrumbusiness.net',
      ui: 'https://cobrowse.portals.uat-spectrum.net',
      smbUi: 'https://cobrowse.portals.uat-spectrumbusiness.net',
      specPortals: 'https://www.portals.uat-spectrum.net',
      smbPortals: 'https://www.portals.uat-spectrumbusiness.net',
    },
    stage: {
      host: 'https://apis-internal-corp.stage-spectrum.net',
      commercialHost: 'https://apis-internal-corp.stage-spectrumbusiness.net',
      loginUrl:
        'https://apis-internal-corp.stage-spectrum.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.stage-spectrum.net',
      smbLoginUrl:
        'https://apis-internal-corp.stage-spectrumbusiness.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.stage-spectrumbusiness.net',
      ui: 'https://cobrowse.stage-spectrum.net',
      smbUi: 'https://cobrowse.stage-spectrumbusiness.net',
      specPortals: 'https://www.stage-spectrum.net',
      smbPortals: 'https://www.stage-spectrumbusiness.net',
    },
    prod: {
      host: 'https://apis-internal-corp.spectrum.net',
      commercialHost: 'https://apis-internal-corp.spectrumbusiness.net',
      loginUrl:
        'https://apis-internal-corp.spectrum.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.spectrum.net',
      smbLoginUrl:
        'https://apis-internal-corp.spectrum.net/auth/oauth/v2/login?client_id=cobrowse_portal&redirect_uri=https://cobrowse.spectrumbusiness.net',
      ui: 'https://cobrowse.spectrum.net',
      smbUi: 'https://cobrowse.spectrumbusiness.net',
      specPortals: 'https://www.spectrum.net',
      smbPortals: 'https://www.spectrumbusiness.net',
    },
  },
  formErrorMessages: {
    apartmentNumberError:
      'Street Number, Street Name and Zip Code OR Street Number, Street Name, City and State required',
    cityError: 'Street Number, Street Name and State required',
    companyError: 'Zip Code required',
    csrFirstNameError: 'Last Name required',
    csrLastNameError: 'First Name required',
    firstNameError: 'Last Name and Zip Code required',
    lastNameError: 'First Name and Zip Code required',
    stateError: 'Street Number, Street Name and City required',
    streetNameError: 'Street Number and Zip Code OR Street Number, City and State required',
    streetNumberError: 'Street Name and Zip Code OR Street Name, City and State required',
    zipError: 'Last name & First name OR Business name OR Street number & name required',
  },
  messages: {
    invalidTokenMessage: 'Token is invalid!',
    noAccessMessage: 'You do not have CoBrowse access!',
    noAccountsMessage: 'No Account Found!',
    noAgentsMessage: 'No Agents Found!',
    noAuthCodeMessage: 'No AuthCode Provided!',
    noReportMessage: 'No data found between these dates!',
    systemErrorMessage: 'There was a system error!',
    unexpectedErrorMessage: 'Unexpected error, please try again!',
    resiAccountMessage:
      'This is a Residential account. Do you want to stay here or get redirected to the CoBrowse Residential Portal?',
    smbAccountMessage:
      'This is a Business account. Do you want to stay here or get redirected to the CoBrowse Business Portal?',
  },
  piService: {
    accessToken: 'access_token',
    agentToken: 'agentJwt',
    authError: 'authz',
    piAuthService: 'auth/oauth/v2/token',
  },
  switchTypes: {
    METASWITCH: 'METASWITCH',
    IMS: 'IMS',
  },
};
